import React from 'react';
import PropTypes from 'prop-types';

import StepTitle from '../StepTitle';
import ShippingForm from './components/ShippingForm';

const Shipping = props => (
  <>
    <StepTitle number="2">Shipping Information</StepTitle>

    <ShippingForm
      shipping={props.shipping}
      onSubmit={props.submitShippingForm}
      updateShipping={props.updateShipping}
      disableSubmitBtn={props.disableSubmitBtn}
      validateFormOnLoad={props.validateFormOnLoad}
      isTradeUser={props.isTradeUser}
    />
  </>
);

Shipping.propTypes = {
  disableSubmitBtn: PropTypes.bool,
  shipping: PropTypes.object,
  submitShippingForm: PropTypes.func.isRequired,
  updateShipping: PropTypes.func.isRequired,
  validateFormOnLoad: PropTypes.bool,
  isTradeUser: PropTypes.bool,
};

export default Shipping;
